import { useEffect, useRef, useState } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api, baseURL } from "../../include/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import AdminFooter from "../common/AdminFooter";
import { useNotification } from "../../Toast/ToastProvider";
import { ERROR, SUCCESS } from "../../include/constant";
import { ChevronDown, MinusCircle, PlusCircle, Trash2, X } from "react-feather";
import Papa from "papaparse";
import "../../styles/CategoryProductList.css";
import { getAdmin } from "../../include/function";

const ListProduct = () => {
  const navigate = useNavigate();
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [ productList, setProductList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const toast = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [extraImageMap, setExtraImageMap] = useState({});
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [importPreview, setImportPreview] = useState([]);
  const [qtyPriceRows, setQtyPriceRows] = useState({});
  const [qtyPriceBasedOn, setQtyPriceBasedOn] = useState({});
  const [showB2C, setShowB2C] = useState(true);
  const [showB2B, setShowB2B] = useState(true);
  const [fileMap, setFileMap] = useState({});
  const fileInputRef = useRef(null);
  const user = getAdmin();
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);

  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });

  const [filterValues, setFilterValues] = useState({
    productId: "",
    brandId: "",
    categoryId: "",
  });
  
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;
      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Products",
          );
          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };
    fetchPermissions();
  }, [user?.roleId]);

  const getCategory = () => {
    setFetchLoading(true);
    Promise.all([
      api.get("/product/", adminReqConfig()),
      api.get("/brand/", adminReqConfig()),
      api.get("/category/?flag=exceptHome", adminReqConfig()),
    ])
      .then(([productRes, brandRes, categoryRes]) => {
        const rawProducts = productRes.data.data || [];
        const allBrandList = brandRes.data.data || [];
        const allCategoryList = categoryRes.data.data || [];

        setBrands(allBrandList);
        setCategories(allCategoryList);
        setAllBrands(allBrandList);
        setAllCategories(allCategoryList);

        const normalizedProducts = rawProducts.map((p) => {
          let brandId = p.brandId != null ? parseInt(p.brandId) : null;
          let categoryId = p.categoryId != null ? parseInt(p.categoryId) : null;

          if (brandId == null && p.brandName) {
            const brandMatch = allBrandList.find(
              (b) => b.name?.toLowerCase() === p.brandName.toLowerCase(),
            );
            brandId = brandMatch ? brandMatch.id : null;
          }

          if (categoryId == null && p.categoryName) {
            const catMatch = allCategoryList.find(
              (c) => c.name?.toLowerCase() === p.categoryName.toLowerCase(),
            );
            categoryId = catMatch ? catMatch.id : null;
          }

          return { ...p, brandId, categoryId };
        });

        setProductList(normalizedProducts);
        setFilteredData(normalizedProducts);
      })
      .catch((error) => {
        toast({ type: ERROR, message: "Error fetching product data" }, error);
        setProductList([]);
        setFilteredData([]);
        setBrands([]);
        setCategories([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setBrands(res.data.data || []));
    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((res) => setCategories(res.data.data || []));
    api
      .get("/product/?limit=200", adminReqConfig())
      .then((res) => setProducts(res.data.data || []));
  }, []);

  useEffect(() => {
    getCategory();
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setAllBrands(res.data.data));
    api
      .get("/category/", adminReqConfig())
      .then((res) => setAllCategories(res.data.data));
  }, []);

  const applyFilters = () => setIsFilterPanelOpen(false);
  const clearFilters = () => {
    const empty = { zone: "", productId: "", brandId: "", categoryId: "" };
    setFilterValues(empty);
    setIsFilterPanelOpen(false);
  };

  const filteredBrands = filterValues.categoryId
    ? brands.filter((brand) =>
        productList.some(
          (p) =>
            p.categoryId === parseInt(filterValues.categoryId) &&
            p.brandId === brand.id,
        ),
      )
    : brands;

  const filteredProducts = filterValues.brandId
    ? productList.filter(
        (p) =>
          p.brandId === parseInt(filterValues.brandId) &&
          (!filterValues.categoryId ||
            p.categoryId === parseInt(filterValues.categoryId)),
      )
    : filterValues.categoryId
      ? productList.filter(
          (p) => p.categoryId === parseInt(filterValues.categoryId),
        )
      : productList;

  useEffect(() => {
    let filtered = productList;

    if (filterValues.brandId) {
      filtered = filtered.filter(
        (product) => product.brandId === parseInt(filterValues.brandId),
      );
    }

    if (filterValues.categoryId) {
      filtered = filtered.filter(
        (product) => product.categoryId === parseInt(filterValues.categoryId),
      );
    }

    if (filterValues.productId) {
      filtered = filtered.filter(
        (product) => product.id === parseInt(filterValues.productId),
      );
    }

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(
        (product) =>
          product.name?.toLowerCase().startsWith(query) ||
          product.categoryName?.toLowerCase().startsWith(query) ||
          product.brandName?.toLowerCase().startsWith(query),
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [filterValues, searchQuery, productList, searchParams]);

  // Pagination Logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;

  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleView = (productId) =>
    navigate(`/admin/product/view/${productId}`);
  const handleEdit = (productId) =>
    navigate(`/admin/product/edit/${productId}`);
  const handleDelete = (productId) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      api
        .delete(`/product/?id=${productId}`,adminReqConfig())
        .then((response) => {
          if (response) {
            toast({ type: SUCCESS, message: response.data.message });
            setProductList((prev) => prev.filter((p) => p.id !== productId));
            setFilteredData((prev) => prev.filter((p) => p.id !== productId));
          }
        })
        .catch((error) => {
          toast({ type: ERROR, message: "Failed to delete product" });
          console.error("Delete error:", error);
        });
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

const handleDownloadCSV = (exportScope = "current") => {
  let dataToExport = [];

  // ✅ PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
  if (selectedData.length > 0) {
    dataToExport = productList.filter((p) => selectedData.includes(p.id));
  } 
  // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
  else if (exportScope === "all") {
    dataToExport = productList;
  } 
  // ✅ PRIORITY 3: Default → export current page items only
  else {
    dataToExport = currentItems;
  }

  if (dataToExport.length === 0) {
    toast({ type: "error", message: "No product data to download" });
    return;
  }

  // Helper: strip HTML and clean text
  const stripHtml = (html) => {
    if (!html || typeof html !== "string") return "-";
    return html.replace(/<[^>]*>/g, "").trim() || "-";
  };

  // Helper: format price
  const formatPrice = (price) =>
    price ? `${parseFloat(price).toFixed(2)}` : "0";

  const productColumns = [
    "S.No",
    "Product ID",
    "Name",
    "Brand Name",
    "Category Name",
    "Description",
    "Highlight",
    "Retail Price",
    "Weight",
    "B2B Price",
    "B2C Price",
    "B2bFlag",
    "B2cFlag",
    "B2bDiscountMode",
    "B2bDiscountValue",
    "B2cDiscountMode",
    "B2cDiscountValue",
    "WarrantyMode",
    "WarrantyPeriod",
    "WarrantyLabel",
    "Grade",
    "Type",
    "Certification",
    "Tax",
    "CGST",
    "SGST",
    "DeliveryCharge",
    "Status",
    "Quantity & Price Tiers",
    "Specifications",
    "Steel Variants",
    "Extra Images",
    "Main Image",
  ];

  const csvData = dataToExport.map((p, i) => {
    const isSteel = ["steel", "steels"].includes(
      (p.categoryName || "").toLowerCase().trim(),
    );
    const hasVariants =
      Array.isArray(p.productVariant) && p.productVariant.length > 0;

    let retailPriceDisplay = "N/A";
    let b2bPriceDisplay = "N/A";
    let b2cPriceDisplay = "N/A";

    if (!isSteel) {
      const basePrice = parseFloat(p.price) || 0;
      retailPriceDisplay = formatPrice(basePrice);

      const b2bDiscountValue = parseFloat(p.b2bDiscountValue) || 0;
      const b2cDiscountValue = parseFloat(p.b2cDiscountValue) || 0;

      const b2bMode = (p.b2bDiscountMode || "").toLowerCase();
      const b2cMode = (p.b2cDiscountMode || "").toLowerCase();

      const b2bPrice =
        b2bMode === "percent"
          ? basePrice - (b2bDiscountValue / 100) * basePrice
          : basePrice - b2bDiscountValue;

      const b2cPrice =
        b2cMode === "percent"
          ? basePrice - (b2cDiscountValue / 100) * basePrice
          : basePrice - b2cDiscountValue;

      b2bPriceDisplay = formatPrice(b2bPrice);
      b2cPriceDisplay = formatPrice(b2cPrice);
    } else {
      retailPriceDisplay = "See Variants";
      b2bPriceDisplay = "See Variants";
      b2cPriceDisplay = "See Variants";
    }

    const qtyPriceRows = Array.isArray(p.qtyAndPrice) ? p.qtyAndPrice : [];
    const qtyPriceStrings = qtyPriceRows
      .map(
        (qp) => `${qp.price} for ${qp.minQty}-${qp.maxQty} (${qp.basedOn})`,
      )
      .join(" | ");

    const specRows = Array.isArray(p.productSpecification)
      ? p.productSpecification
      : [];
    const specStrings = specRows
      .map((spec) => {
        const safeTitle = String(spec.title || "").replace(/[:|]/g, ";");
        const safeDesc = String(spec.description || "").replace(
          /[:|\r]/g,
          ";",
        );
        return `${safeTitle}: ${safeDesc}`;
      })
      .join(" | ");

    let steelVariantStrings = "";
    if (isSteel && hasVariants) {
      steelVariantStrings = p.productVariant
        .map((v) => {
          const parts = [`Dia: ${v.title}`];
          const retail = parseFloat(v.price) || 0;
          parts.push(`Retail: ${retail.toFixed(2)}`);

          if (v.b2cDiscountMode) {
            const b2cMode = (v.b2cDiscountMode || "").toLowerCase();
            const b2cFinal =
              b2cMode === "percent"
                ? retail -
                  (parseFloat(v.b2cDiscountValue || 0) / 100) * retail
                : retail - parseFloat(v.b2cDiscountValue || 0);
            parts.push(
              `B2C: ${b2cFinal.toFixed(2)} (${v.b2cDiscountValue} ${
                v.b2cDiscountMode
              })`,
            );
          }

          if (v.b2bDiscountMode) {
            const b2bMode = (v.b2bDiscountMode || "").toLowerCase();
            const b2bFinal =
              b2bMode === "percent"
                ? retail -
                  (parseFloat(v.b2bDiscountValue || 0) / 100) * retail
                : retail - parseFloat(v.b2bDiscountValue || 0);
            parts.push(
              `B2B: ${b2bFinal.toFixed(2)} (${v.b2bDiscountValue} ${
                v.b2bDiscountMode
              }) Rate: ${v.rateValue || "N/A"}`,
            );
          }

          return parts.join(", ");
        })
        .join(" | ");
    } else if (isSteel) {
      steelVariantStrings = "No variants";
    }

    const extraImageUrls = Array.isArray(p.images)
      ? p.images
          .map((img) => (img.imageUrl ? `${baseURL}/${img.imageUrl}` : ""))
          .join(", ")
      : "";
    const mainImageUrl = p.mainImage ? `${baseURL}/${p.mainImage}` : "-";

    return {
      "S.No": i + 1,
      "Product ID": p.id || "-",
      Name: p.name || "-",
      "Brand Name": p.brandName || "N/A",
      "Category Name": p.categoryName || "N/A",
      Description: stripHtml(p.description),
      Highlight: stripHtml(p.highlight),
      "Retail Price": retailPriceDisplay,
      Weight: p.weight,
      "B2B Price": b2bPriceDisplay,
      "B2C Price": b2cPriceDisplay,
      B2bFlag: p.b2bFlag === 1 || p.b2bFlag === "1" ? "Yes" : "No",
      B2cFlag: p.b2cFlag === 1 || p.b2cFlag === "1" ? "Yes" : "No",
      B2bDiscountMode: p.b2bDiscountMode || "-",
      B2bDiscountValue: p.b2bDiscountValue || "0",
      B2cDiscountMode: p.b2cDiscountMode || "-",
      B2cDiscountValue: p.b2cDiscountValue || "0",
      WarrantyMode: p.warrantyMode || "-",
      WarrantyPeriod: p.warrantyPeriod || "-",
      WarrantyLabel: p.warrantyLabel || "-",
      Grade: p.grade || "-",
      Type: p.type || "-",
      Certification: p.certification || "-",
      Tax: p.tax || "0",
      CGST: p.cgst || "0",
      SGST: p.sgst || "0",
      DeliveryCharge: p.deliveryCharge || "0",
      Status: p.status || "-",
      "Quantity & Price Tiers": qtyPriceStrings || "-",
      Specifications: specStrings || "-",
      "Steel Variants": steelVariantStrings || "",
      "Extra Images": extraImageUrls || "-",
      "Main Image": mainImageUrl,
    };
  });

  // ✅ CRITICAL FIX: Proper object syntax with "data:" key
  const csv = Papa.unparse({
    fields: productColumns,
    data: csvData.map((row) => {
      return productColumns.map((col) => row[col]);
    })
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  
  // ✅ Dynamic filename based on export type
  const fileName = selectedData.length > 0 
    ? `Product_Selected_${selectedData.length}.csv`
    : exportScope === "all" 
      ? "Product_All.csv" 
      : `Product_Page${currentPage}.csv`;
    
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const handleDownloadSampleCSV = () => {
    const sampleHeaders = [
      "Name",
      "Brand Name",
      "Category Name",
      "Retail Price",
      "Description",
      "Highlight",
      "B2bFlag",
      "B2bDiscountMode",
      "B2bDiscountValue",
      "B2cFlag",
      "B2cDiscountMode",
      "B2cDiscountValue",
      "Grade",
      "Type",
      "Certification",
      "tax",
      "cgst",
      "sgst",
      "DeliveryCharge",
      "Status",
      "QtyBasedOn",
      "QtyMin",
      "QtyMax",
      "QtyPrice",
      "SpecTitle",
      "SpecValue",
      "SpecType",
      "SpecGroup",
      "SpecOptions",
      "SteelDiameter",
      "SteelRetailPrice",
      "SteelB2CMode",
      "SteelB2CValue",
      "SteelB2BMode",
      "SteelB2BValue",
      "SteelPriceDiff",
      "SteelRateValue",
    ];

    const sampleRows = [
      [
        "OPC 53 Grade Cement",
        "UltraTech",
        "Cement",
        "420",
        "<p>High strength</p>",
        "<p>IS Certified</p>",
        "Yes",
        "Amount",
        "20",
        "Yes",
        "Percent",
        "5",
        "53",
        "OPC",
        "IS 269",
        "18",
        "9",
        "9",
        "50",
        "active",
        "bags",
        "1",
        "10",
        "400",
        "Color",
        "Grey",
        "TEXT",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      [
        "TMT Steel Bars",
        "JSW",
        "Steel",
        "0",
        "<p>Fe 500D</p>",
        "<p>Earthquake Resistant</p>",
        "Yes",
        "",
        "",
        "Yes",
        "",
        "",
        "Fe 500D",
        "",
        "IS 1786",
        "18",
        "9",
        "9",
        "0",
        "active",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "06 mm",
        "70",
        "Amount",
        "2",
        "Percent",
        "3",
        "Amount",
        "1.5",
      ],
    ];

    const csvContent = [
      sampleHeaders.join(","),
      ...sampleRows.map((row) =>
        row
          .map((field) =>
            field?.toString().includes(",") ||
            field?.toString().includes('"') ||
            field?.toString().includes("\n")
              ? `"${field?.toString().replace(/"/g, '""') || ""}"`
              : field || "",
          )
          .join(","),
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Product_Sample_Import.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith(".csv")) {
      toast({ type: ERROR, message: "Please upload a CSV file." });
      return;
    }

    setFetchLoading(true);
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const { data } = results;
        if (data.length === 0) {
          toast({ type: ERROR, message: "CSV file is empty." });
          setFetchLoading(false);
          return;
        }

        const rawHeaders = Object.keys(data[0] || {});
        const normalizedHeaderMap = {};
        rawHeaders.forEach((h) => {
          const cleanKey = h
            .toLowerCase()
            .replace(/\s+/g, "")
            .replace(/[^a-z0-9]/g, "");
          normalizedHeaderMap[cleanKey] = h;
        });

        const getField = (row, ...keys) => {
          for (const key of keys) {
            const clean = key
              .toLowerCase()
              .replace(/\s+/g, "")
              .replace(/[^a-z0-9]/g, "");
            const originalHeader = normalizedHeaderMap[clean];
            if (
              originalHeader !== undefined &&
              row[originalHeader] !== undefined
            ) {
              return row[originalHeader];
            }
          }
          return "";
        };

        const productMap = {};
        data.forEach((row) => {
          const name = getField(row, "Name").trim();
          if (!name) return;

          const brandName = getField(row, "Brand Name", "Brand").trim();
          const categoryName = getField(
            row,
            "Category Name",
            "Category",
          ).trim();
          const key = `${name}|${brandName}|${categoryName}`;
          const isSteelCategory = ["steel", "steels"].includes(
            categoryName.toLowerCase(),
          );

          if (!productMap[key]) {            
            productMap[key] = {
              id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
              Name: name,
              BrandName: brandName,
              CategoryName: categoryName,
              RetailPrice: isSteelCategory
                ? "0"
                : getField(row, "Retail Price", "Price", "RetailPrice") || "0",
              Weight: isSteelCategory
                ? ""
                : getField(row, "Weight", "Wt") || "",
              Description: getField(row, "Description", "Desc").trim() || "",
              Highlight: getField(row, "Highlight", "Highlights").trim() || "",
              B2bFlag: ["yes", "1", "true"].includes(
                getField(row, "B2bFlag").toLowerCase(),
              ),
              B2bDiscountMode: ["amount", "percent","Amount","Percent"].includes(
                getField(row, "B2bDiscountMode"),
              )
                ? getField(row, "B2bDiscountMode")
                : "",
              B2bDiscountValue: getField(row, "B2bDiscountValue") || "0",
              B2cFlag: ["yes", "1", "true"].includes(
                getField(row, "B2cFlag").toLowerCase(),
              ),
              B2cDiscountMode: ["Amount", "Percent","amount","percent"].includes(
                getField(row, "B2cDiscountMode"),
              )
                ? getField(row, "B2cDiscountMode")
                : "",
              B2cDiscountValue: getField(row, "B2cDiscountValue") || "0",
              Grade: getField(row, "Grade").trim() || "",
              Type: getField(row, "Type").trim() || "",
              Certification:
                getField(row, "Certification", "Cert").trim() || "",
              tax: getField(row, "tax", "Tax") || "0",
              cgst: getField(row, "cgst", "CGST") || "0",
              sgst: getField(row, "sgst", "SGST") || "0",
              DeliveryCharge:
                getField(row, "DeliveryCharge", "Delivery Charge") || "0",
              Status: ["active", "1", "true"].includes(
                getField(row, "Status").toLowerCase(),
              )
                ? "active"
                : "inactive",
              WarrantyMode:
                getField(row, "WarrantyMode", "WarrentyMode").trim() || "",
              WarrantyPeriod:
                getField(row, "WarrantyPeriod", "WarrentyPeriod").trim() || "0",
              WarrantyLabel:
                getField(row, "WarrantyLabel", "WarrentyLabel").trim() || "",
              specs: [],
              qtyTiers: [],
              steelVariants: [],
              selectedVariantIndex: null,
            };
          }

          // === Handle Specifications ===
          const specTitle = getField(row, "SpecTitle", "SpecificationTitle");
          const specValue = getField(row, "SpecValue", "SpecificationValue");
          const specType = getField(row, "SpecType", "SpecificationType");
          const specGroup = getField(row, "SpecGroup", "SpecificationGroup");
          const specOptions = getField(
            row,
            "SpecOptions",
            "SpecificationOptions",
          );
          if (specTitle && specType) {
            let fieldType = specType.trim().toUpperCase();
            if (fieldType === "DROPDOWN") fieldType = "DROPDOWN LIST";
            productMap[key].specs.push({
              groupName: specGroup.trim() || "General",
              title: specTitle.trim(),
              value: specValue.trim(),
              fieldType,
              options: specOptions.trim(),
            });
          }

          // === Handle Qty & Price Tiers ===
          const qtyBasedOn = getField(row, "QtyBasedOn", "Qty Based On");
          const qtyMin = getField(row, "QtyMin", "Qty Min");
          const qtyMax = getField(row, "QtyMax", "Qty Max");
          const qtyPrice = getField(row, "QtyPrice", "Qty Price");
          if (qtyBasedOn && qtyMin && qtyMax && qtyPrice) {
            productMap[key].qtyTiers.push({
              basedOn: qtyBasedOn.trim(),
              min: qtyMin.trim(),
              max: qtyMax.trim(),
              price: qtyPrice.trim(),
            });
          }

          // ✅ === FIX: PARSE STEEL VARIANTS FROM "Steel Variants" COLUMN ===
          if (isSteelCategory) {
            const steelVariantsStr = getField(
              row,
              "Steel Variants",
              "SteelVariants",
            );
            if (
              steelVariantsStr &&
              steelVariantsStr.trim() !== "" &&
              steelVariantsStr !== "No variants"
            ) {
              // Split by " | " to get each variant string
              const variantStrings = steelVariantsStr
                .split(" | ")
                .filter((s) => s.trim() !== "");
              variantStrings.forEach((variantStr) => {
                const variant = {
                  diameter: "",
                  retailPrice: "0",
                  b2cMode: "",
                  b2cValue: "0",
                  b2bMode: "",
                  b2bValue: "0",
                  priceDiff: "",
                  rateValue: "0",
                };

                // Extract Diameter: Dia: 06 mm
                const diaMatch = variantStr.match(/Dia:\s*([^,]+)/);
                if (diaMatch) variant.diameter = diaMatch[1].trim();

                // Extract Retail: Retail: 63.50
                const retailMatch = variantStr.match(/Retail:\s*([\d.]+)/);
                if (retailMatch) variant.retailPrice = retailMatch[1];

                // Extract B2C: B2C: 63.00 (0.5 Amount)
                const b2cMatch = variantStr.match(
                  /B2C:\s*[\d.]+\s*\(([^)]+)\)/,
                );
                if (b2cMatch) {
                  const b2cParts = b2cMatch[1].trim().split(" ");
                  if (b2cParts.length === 2) {
                    variant.b2cValue = b2cParts[0];
                    variant.b2cMode = b2cParts[1];
                  }
                }

                // Extract B2B: B2B: 62.00 (1.5 Amount) Rate: 1
                const b2bMatch = variantStr.match(
                  /B2B:\s*[\d.]+\s*\(([^)]+)\)\s*Rate:\s*([\d.]+)/,
                );
                if (b2bMatch) {
                  const b2bParts = b2bMatch[1].trim().split(" ");
                  if (b2bParts.length === 2) {
                    variant.b2bValue = b2bParts[0];
                    variant.b2bMode = b2bParts[1];
                    variant.rateValue = b2bMatch[2];
                    // priceDiff is same as b2bMode for B2B
                    variant.priceDiff = b2bParts[1];
                  }
                }

                if (variant.diameter) {
                  productMap[key].steelVariants.push(variant);
                }
              });

              // ✅ Auto-select the first variant to populate UI
              if (productMap[key].steelVariants.length > 0) {
                productMap[key].selectedVariantIndex = 0;
                productMap[key].RetailPrice =
                  productMap[key].steelVariants[0].retailPrice || "0";
              }
            }
          }
        });

        const previewList = Object.values(productMap).filter((p) => p.Name);
        if (previewList.length === 0) {
          toast({ type: ERROR, message: "No valid products found in CSV." });
          setFetchLoading(false);
          return;
        }

        setImportPreview(previewList);
        setFetchLoading(false);
        setIsImportModalOpen(true);
      },
      error: (error) => {
        console.error("CSV Parse Error:", error);
        toast({ type: ERROR, message: "Failed to parse CSV file." });
        setFetchLoading(false);
      },
    });
  };

  const handleStatusChange = (productId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const payload = { status: newStatus };

    api
      .put(
        `/product/?id=${productId}&flag=changeStatus`,
        payload,
        adminReqConfig(),
      )
      .then((response) => {
        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: `Product ${newStatus} successfully!`,
          });
          setProductList((prev) =>
            prev.map((p) =>
              p.id === productId ? { ...p, status: newStatus } : p,
            ),
          );
          setFilteredData((prev) =>
            prev.map((p) =>
              p.id === productId ? { ...p, status: newStatus } : p,
            ),
          );
        }
      })
      .catch((error) => {
        console.error("Status update failed:", error);
        toast({ type: ERROR, message: "Failed to update product status." });
      });
  };

  const getBrandsByCategory = (categoryName) => {
    if (!categoryName) return allBrands;
    const category = allCategories.find(
      (cat) => cat.name?.toLowerCase() === categoryName.toLowerCase(),
    );
    if (!category) return allBrands;
    return allBrands.filter(
      (brand) =>
        brand.categoryId != null && parseInt(brand.categoryId) === category.id,
    );
  };

  const handlePreviewFieldChange = (id, field, value) => {
    setImportPreview((prev) =>
      prev.map((row) => {
        if (row.id !== id) return row;
        const updated = { ...row, [field]: value };
        if (field === "CategoryName") {
          updated.BrandName = "";
        }
        return updated;
      }),
    );
  };

  const handleStartImport = async () => {
    if (importPreview.length === 0) return;
    setFetchLoading(true);
    let successCount = 0;
    let errorCount = 0;

    const brandMap = {};
    allBrands.forEach((b) => {
      if (b.name) brandMap[b.name.trim().toLowerCase()] = b.id;
    });

    const categoryMap = {};
    allCategories.forEach((c) => {
      if (c.name) categoryMap[c.name.trim().toLowerCase()] = c.id;
    });

    for (const item of importPreview) {
      const {
        Name,
        BrandName,
        CategoryName,
        RetailPrice,
        Weight,
        Description,
        Highlight,
        B2bFlag,
        B2bDiscountMode,
        B2bDiscountValue,
        B2cFlag,
        B2cDiscountMode,
        B2cDiscountValue,
        Grade,
        Type,
        Certification,
        tax = "0",
        cgst = "0",
        sgst = "0",
        DeliveryCharge = "0",
        Status = "active",
        specs = [],
        steelVariants = [],
        WarrantyMode = "",
        WarrantyPeriod = "0",
        WarrantyLabel = "",
      } = item;

      const brandId = brandMap[BrandName.trim().toLowerCase()];
      const categoryId = categoryMap[CategoryName.trim().toLowerCase()];
      const categoryObj = allCategories.find((c) => c.id === categoryId);
      const categoryName = categoryObj?.name || "";
      const isSteelCategory = ["steel", "steels"].includes(
        (categoryName || "").toLowerCase(),
      );

      if (!Name || !brandId || !categoryId) {
        console.warn("Skipping row due to missing Name/Brand/Category:", item);
        errorCount++;
        continue;
      }

      try {
        const formData = new FormData();
        formData.append("name", Name.trim());
        formData.append("brandId", brandId);
        formData.append("category", JSON.stringify([categoryId]));
        formData.append("description", Description?.trim() || "");
        formData.append("highlight", Highlight?.trim() || "");
        formData.append("code", "0");
        formData.append(
          "price",
          isSteelCategory ? "0" : (RetailPrice || "0").toString(),
        );
        formData.append("status", Status || "active");
        formData.append("b2bFlag", B2bFlag ? "1" : "0");
        formData.append("b2cFlag", B2cFlag ? "1" : "0");
        formData.append("b2bDiscountMode", B2bDiscountMode || "");
        formData.append("b2bDiscountValue", B2bDiscountValue || "0");
        formData.append("b2cDiscountMode", B2cDiscountMode || "");
        formData.append("b2cDiscountValue", B2cDiscountValue || "0");
        formData.append("grade", Grade || "");
        formData.append("type", Type || "");
        formData.append("certification", Certification || "");
        formData.append("tax", (tax || "0").toString());
        formData.append("cgst", (cgst || "0").toString());
        formData.append("sgst", (sgst || "0").toString());
        formData.append("deliveryCharge", (DeliveryCharge || "0").toString());
        formData.append("shopId", String(user.id));
        formData.append("stockAvail", "yes");
        formData.append("warrantyMode", WarrantyMode.trim());
        formData.append("warrantyPeriod", (WarrantyPeriod || "0").toString());
        formData.append("warrantyLabel", WarrantyLabel.trim());
        formData.append(
          "weight",
          isSteelCategory ? "" : (Weight || "").toString(),
        );
        const mainImageFile = fileMap[item.id];
        if (mainImageFile) {
          formData.append("mainImage", mainImageFile);
        }

        const extraFiles = extraImageMap[item.id] || [];
        extraFiles.forEach((file) => formData.append("extraImages[]", file));

        const res = await api.post("/product/", formData, adminReqConfig());
        if (![200, 201].includes(res.status)) {
          errorCount++;
          continue;
        }

        const productId = res.data.data?.id;
        if (!productId) {
          errorCount++;
          continue;
        }

        // ✅ Save Specifications
        if (specs.length > 0) {
          const specPayload = specs.map((spec) => ({
            productId,
            groupName: spec.groupName || "General",
            title: spec.title,
            description: spec.value,
          }));
          await api.post(
            "/product_specification/",
            specPayload,
            adminReqConfig(),
          );
        }

        // ✅ Save Quantity & Price Tiers (Non-Steel products only)
        if (!isSteelCategory) {
          const rows = qtyPriceRows[item.id] || [];
          const basedOn = qtyPriceBasedOn[item.id] || "bags";
          const validTiers = rows
            .filter((r) => r.min && r.max && (r.setB2bPrice || r.setB2cPrice))
            .map((r) => ({
              productId,
              basedOn,
              minQty: String(r.min),
              maxQty: String(r.max),
              setB2cPrice: showB2C ? String(r.setB2cPrice || "") : "",
              setB2bPrice: showB2B ? String(r.setB2bPrice || "") : "",
            }));

          if (validTiers.length > 0) {
            await api.post("/product_qty_price/", validTiers, adminReqConfig());
          }
        }

        // ✅ Save Steel Variants
        if (isSteelCategory && steelVariants.length > 0) {
          const updatedVariants = [...steelVariants];
          if (
            item.selectedVariantIndex != null &&
            updatedVariants[item.selectedVariantIndex]
          ) {
            updatedVariants[item.selectedVariantIndex] = {
              ...updatedVariants[item.selectedVariantIndex],
              retailPrice:
                item.RetailPrice ||
                updatedVariants[item.selectedVariantIndex].retailPrice ||
                "0",
              b2cMode:
                item.B2cDiscountMode !== ""
                  ? item.B2cDiscountMode
                  : updatedVariants[item.selectedVariantIndex].b2cMode || "",
              b2cValue:
                item.B2cDiscountValue !== ""
                  ? item.B2cDiscountValue
                  : updatedVariants[item.selectedVariantIndex].b2cValue || "0",
              b2bMode:
                item.B2bDiscountMode !== ""
                  ? item.B2bDiscountMode
                  : updatedVariants[item.selectedVariantIndex].b2bMode || "",
              b2bValue:
                item.B2bDiscountValue !== ""
                  ? item.B2bDiscountValue
                  : updatedVariants[item.selectedVariantIndex].b2bValue || "0",
            };
          }

          const variantPayload = updatedVariants
            .map((v) => {
              if (!v.b2bMode && !v.b2cMode) return null;
              return {
                productId,
                title: v.diameter,
                price: v.retailPrice || "0",
                b2cDiscountMode: v.b2cMode || "",
                b2cDiscountValue: v.b2cValue || "0",
                b2bDiscountMode: v.b2bMode || "",
                b2bDiscountValue: v.b2bValue || "0",
                priceDiff: v.b2bMode || "",
                rateValue: v.rateValue || "0",
              };
            })
            .filter(Boolean);

          if (variantPayload.length > 0) {
            await api.post(
              "/product_variant/",
              variantPayload,
              adminReqConfig(),
            );
          }
        }

        successCount++;
      } catch (err) {
        console.error("Import failed for product:", Name, err);
        errorCount++;
      }
    }

    if (successCount > 0) {
      toast({
        type: SUCCESS,
        message: `${successCount} product(s) imported successfully!`,
      });
      getCategory();
    }

    if (errorCount > 0) {
      toast({
        type: ERROR,
        message: `${errorCount} product(s) failed to import. Check Brand/Category names and CSV format.`,
      });
    }

    setFetchLoading(false);
    setIsImportModalOpen(false);
    setImportPreview([]);
    setFileMap({});
    setExtraImageMap({});
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);

  const filterWrapperRef = useRef(null);

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => {
      const updated = { ...prev, [key]: value };
      if (key === "categoryId") {
        updated.brandId = "";
        updated.productId = "";
      } else if (key === "brandId") {
        updated.productId = "";
      }
      return updated;
    });
  };

  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="PRODUCTS"
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {fetchLoading ? (
            <p>Loading products...</p>
          ) : (
            <>
              <div className="rounded-5 bg-white py-24">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-auto">
                    <h6 className="mb-0">All Products</h6>
                  </div>
                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{ position: "relative", width: "500px" }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                          />
                           {searchQuery && (
                                                    <X
                                                      size={24}
                                                      onClick={(e) => {
                                                        e.stopPropagation(); 
                                                        setSearchQuery(""); 
                                                        setCurrentPage(1);
                                                        setIsFilterPanelOpen(false);
                                                      }}
                                                      style={{
                                                        position: "absolute",
                                                        right: "40px", 
                                                        cursor: "pointer",
                                                        color: "#999",
                                                        padding: "4px",
                                                        zIndex: 10,
                                                      }}
                                                      onMouseEnter={(e) =>
                                                        (e.currentTarget.style.color = "#666")
                                                      }
                                                      onMouseLeave={(e) =>
                                                        (e.currentTarget.style.color = "#999")
                                                      }
                                                    />
                                                  )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>
                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={handleFilterChange}
                          onApply={applyFilters}
                          onClear={clearFilters}
                          brands={filteredBrands}
                          categories={categories}
                          products={filteredProducts}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex col-auto">
                    {productPermissions.add && (
                      <button
                        className="btn btn-primary me-8 mb-3"
                        style={{ height: "40px", width: "140px" }}
                        onClick={() => navigate("/admin/product/productAddNew")}
                      >
                        Add New
                      </button>
                    )}
                    <div className="">
                      <CustomDropdown
                        handleDownloadCSV={handleDownloadCSV}
                        handleOpenImportInstructions={() => {
                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                            fileInputRef.current.click();
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{
                            width: "80px",
                            fontSize: "15px",
                            textWrap: "nowrap",
                          }}
                        >
                          Image
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Product Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Category
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Brand
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Retail Price
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          B2b Selling Price
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          B2c Selling Price
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          style={{
                            width: "120px",
                            fontSize: "15px",
                            textAlign: "center",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((product) => {
                          const isSteel =
                            product.categoryName &&
                            (product.categoryName.toLowerCase() === "steel" ||
                              product.categoryName.toLowerCase() === "steels");

                          let productPriceDisplay = "0";
                          let b2bPriceDisplay = "0";
                          let b2cPriceDisplay = "0";

                          if (
                            isSteel &&
                            Array.isArray(product.productVariant) &&
                            product.productVariant.length > 0
                          ) {
                            const variantPrices = product.productVariant
                              .map((v) => parseFloat(v.price))
                              .filter((p) => !isNaN(p));

                            const b2bPrices = product.productVariant
                              .map((v) => {
                                const base = parseFloat(v.price);
                                if (isNaN(base)) return null;
                                const b2bMode = (
                                  v.b2bDiscountMode || ""
                                ).toLowerCase();
                                const disc =
                                  parseFloat(v.b2bDiscountValue) || 0;
                                return b2bMode === "percent"
                                  ? base - (disc / 100) * base
                                  : base - disc;
                              })
                              .filter((p) => p !== null && !isNaN(p));

                            const b2cPrices = product.productVariant
                              .map((v) => {
                                const base = parseFloat(v.price);
                                if (isNaN(base)) return null;
                                const b2cMode = (
                                  v.b2cDiscountMode || ""
                                ).toLowerCase();
                                const disc =
                                  parseFloat(v.b2cDiscountValue) || 0;
                                return b2cMode === "percent"
                                  ? base - (disc / 100) * base
                                  : base - disc;
                              })
                              .filter((p) => p !== null && !isNaN(p));

                            const minPrice = variantPrices.length
                              ? Math.min(...variantPrices)
                              : 0;
                            const maxPrice = variantPrices.length
                              ? Math.max(...variantPrices)
                              : 0;
                            const minB2B = b2bPrices.length
                              ? Math.min(...b2bPrices)
                              : 0;
                            const maxB2B = b2bPrices.length
                              ? Math.max(...b2bPrices)
                              : 0;
                            const minB2C = b2cPrices.length
                              ? Math.min(...b2cPrices)
                              : 0;
                            const maxB2C = b2cPrices.length
                              ? Math.max(...b2cPrices)
                              : 0;

                            productPriceDisplay = variantPrices.length
                              ? minPrice === maxPrice
                                ? `₹${minPrice.toFixed(2)}`
                                : `₹${minPrice.toFixed(
                                    2,
                                  )} – ₹${maxPrice.toFixed(2)}`
                              : "0";

                            b2bPriceDisplay = b2bPrices.length
                              ? minB2B === maxB2B
                                ? `₹${minB2B.toFixed(2)}`
                                : `₹${minB2B.toFixed(2)} – ₹${maxB2B.toFixed(
                                    2,
                                  )}`
                              : "0";

                            b2cPriceDisplay = b2cPrices.length
                              ? minB2C === maxB2C
                                ? `₹${minB2C.toFixed(2)}`
                                : `₹${minB2C.toFixed(2)} – ₹${maxB2C.toFixed(
                                    2,
                                  )}`
                              : "0";
                          } else {
                            // ✅ FIXED: Normalize discount modes to lowercase
                            const price = parseFloat(product.price) || 0;
                            const b2bDiscountValue =
                              parseFloat(product.b2bDiscountValue) || 0;
                            const b2cDiscountValue =
                              parseFloat(product.b2cDiscountValue) || 0;

                            const b2bMode = (
                              product.b2bDiscountMode || ""
                            ).toLowerCase();
                            const b2cMode = (
                              product.b2cDiscountMode || ""
                            ).toLowerCase();

                            const b2bPrice =
                              b2bMode === "percent"
                                ? price - (b2bDiscountValue / 100) * price
                                : price - b2bDiscountValue;

                            const b2cPrice =
                              b2cMode === "percent"
                                ? price - (b2cDiscountValue / 100) * price
                                : price - b2cDiscountValue;

                            productPriceDisplay = `₹${price.toFixed(2)}`;
                            b2bPriceDisplay = `₹${b2bPrice.toFixed(2)}`;
                            b2cPriceDisplay = `₹${b2cPrice.toFixed(2)}`;
                          }

                          return (
                            <tr key={product.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  style={{ borderColor: "#c5d5f5" }}
                                  className="form-check-input"
                                  checked={selectedData.includes(product.id)}
                                  onChange={() => handleSelectOne(product.id)}
                                />
                              </td>
                              <td>
                                <div
                                  style={{
                                    backgroundColor: "#e9f0f4",
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src={baseURL + "/" + product.mainImage}
                                    alt={product.name}
                                    style={{
                                      width: "80%",
                                      height: "80%",
                                      objectFit: "fill",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              </td>
                              <td>{product.name}</td>
                              <td>{product.categoryName || "N/A"}</td>
                              <td>{product.brandName || "N/A"}</td>
                              <td>{productPriceDisplay}</td>
                              <td>{b2bPriceDisplay}</td>
                              <td>{b2cPriceDisplay}</td>
                              <td>
                                <div className="form-check form-switch">
                                  <input
                                    className={`form-check-input form-product-status-switch ${
                                      product.status === "active"
                                        ? "switch-green"
                                        : "switch-orange"
                                    }`}
                                    type="checkbox"
                                    id={`statusSwitch-${product.id}`}
                                    checked={product.status === "active"}
                                    onChange={() =>
                                      handleStatusChange(
                                        product.id,
                                        product.status,
                                      )
                                    }
                                  />
                                </div>
                              </td>
                              <td style={{ position: "relative" }}>
                                <div className="d-flex gap-1">
                                  {productPermissions.view && (
                                    <button
                                      style={{
                                        backgroundColor: "#D9EBFF",
                                        height: "39px",
                                        width: "50px",
                                        border: "none",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        color: "inherit",
                                        outline: "none",
                                      }}
                                      onClick={() => handleView(product.id)}
                                    >
                                      <img
                                        src="/assets/images/view-icon.png"
                                        alt="View"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) =>
                                          (e.target.style.display = "none")
                                        }
                                      />
                                    </button>
                                  )}
                                  {productPermissions.edit && (
                                    <button
                                      style={{
                                        backgroundColor: "#D9EBFF",
                                        height: "39px",
                                        width: "50px",
                                        border: "none",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        color: "inherit",
                                        outline: "none",
                                      }}
                                      onClick={() => handleEdit(product.id)}
                                    >
                                      <img
                                        src="/assets/images/edit-icon.png"
                                        alt="Edit"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) =>
                                          (e.target.style.display = "none")
                                        }
                                      />
                                    </button>
                                  )}
                                  {productPermissions.delete && (
                                    <button
                                      style={{
                                        backgroundColor: "#D9EBFF",
                                        height: "39px",
                                        width: "50px",
                                        border: "none",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        color: "inherit",
                                        outline: "none",
                                      }}
                                      onClick={() => handleDelete(product.id)}
                                    >
                                      <img
                                        src="/assets/images/delete-icon.png"
                                        alt="Delete"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) =>
                                          (e.target.style.display = "none")
                                        }
                                      />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No products found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Lists
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>

      {/* Import Preview Modal */}
      {isImportModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            backdropFilter: "blur(2px)",
          }}
          onClick={() => setIsImportModalOpen(false)}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "900px",
              maxHeight: "85vh",
              overflowY: "auto",
              padding: "24px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              border: "1px solid #eee",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => {
                setIsImportModalOpen(false);
                setImportPreview([]);
                setFileMap({});
              }}
              style={{
                position: "absolute",
                borderRadius: "50%",
                top: "12px",
                right: "12px",
                background: "#D9EBFF",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#2696D5",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              &times;
            </button>
            <h6 className="mb-12">Import Preview</h6>
            <div
              style={{
                marginBottom: "20px",
                fontSize: "14px",
                color: "#444",
                lineHeight: "1.6",
              }}
            >
              <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                * Product Name must be unique.
              </p>
              <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                * Please choose images before importing!
              </p>
            </div>
            <div
              className="table-responsive"
              style={{ maxHeight: "400px", overflowY: "auto" }}
            >
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Category
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Brand
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Weight
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Price
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      B2bDiscountMode
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      B2bDiscountValue
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      B2cDiscountMode
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      B2cDiscountValue
                    </th>
                    {importPreview.some(
                      (row) =>
                        !["steel", "steels"].includes(
                          (row.CategoryName || "").toLowerCase(),
                        ),
                    ) && (
                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Set Quantity & Price
                      </th>
                    )}
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      B2B
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      B2C
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Highlight
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Image
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Extra Images
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Warranty Mode
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Warranty Period
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Warranty Label
                    </th>
                    <th
                      scope="col"
                      style={{ fontSize: "15px", textWrap: "nowrap" }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* Import Preview Modal - inside table body */}
                  {importPreview.map((row) => (
                    <tr key={row.id}>
                      {/* Name */}
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={row.Name}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "Name",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "100px" }}
                        />
                      </td>
                      {/* Category */}
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.CategoryName || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "CategoryName",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "100px" }}
                        >
                          <option value="">Select Category</option>
                          {allCategories.map((c) => (
                            <option key={c.id} value={c.name}>
                              {c.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      {/* Brand */}
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.BrandName || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "BrandName",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "100px" }}
                        >
                          <option value="">Select Brand</option>
                          {getBrandsByCategory(row.CategoryName).map((b) => (
                            <option key={b.id} value={b.name}>
                              {b.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      {/* Weight */}
                      <td>
                        {row.CategoryName &&
                        ["steel", "steels"].includes(
                          row.CategoryName.toLowerCase(),
                        ) ? (
                          <span style={{ fontSize: "11px", color: "#999" }}>
                            N/A
                          </span>
                        ) : (
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={row.Weight || ""}
                            onChange={(e) =>
                              handlePreviewFieldChange(
                                row.id,
                                "Weight",
                                e.target.value,
                              )
                            }
                            style={{ fontSize: "11px", width: "80px" }}
                            placeholder="Kg"
                          />
                        )}
                      </td>
                      {/* Price + B2B + B2C for Steel */}
                      <td>
                        {row.CategoryName &&
                        ["steel", "steels"].includes(
                          row.CategoryName.toLowerCase(),
                        ) ? (
                          <div
                            className="d-flex flex-column gap-1"
                            style={{ width: "180px", fontSize: "11px" }}
                          >
                            {/* Variant Selector */}
                            <select
                              className="form-select form-select-sm"
                              value={row.selectedVariantIndex ?? ""}
                              onChange={(e) => {
                                const idx =
                                  e.target.value === ""
                                    ? null
                                    : Number(e.target.value);
                                const updatedRow = {
                                  ...row,
                                  selectedVariantIndex: idx,
                                };
                                if (idx !== null && row.steelVariants[idx]) {
                                  const v = row.steelVariants[idx];
                                  updatedRow.RetailPrice = v.retailPrice || "0";
                                  updatedRow.B2bDiscountMode = v.b2bMode || "";
                                  updatedRow.B2bDiscountValue =
                                    v.b2bValue || "0";
                                  updatedRow.B2cDiscountMode = v.b2cMode || "";
                                  updatedRow.B2cDiscountValue =
                                    v.b2cValue || "0";
                                } else {
                                  updatedRow.RetailPrice = "0";
                                  updatedRow.B2bDiscountMode = "";
                                  updatedRow.B2bDiscountValue = "0";
                                  updatedRow.B2cDiscountMode = "";
                                  updatedRow.B2cDiscountValue = "0";
                                }
                                setImportPreview((prev) =>
                                  prev.map((p) =>
                                    p.id === row.id ? updatedRow : p,
                                  ),
                                );
                              }}
                              style={{ fontSize: "11px", padding: "2px 4px" }}
                            >
                              <option value="">-- Select Variant --</option>
                              {row.steelVariants?.map((variant, idx) => (
                                <option key={idx} value={idx}>
                                  {variant.diameter}
                                </option>
                              ))}
                            </select>
                            {/* Retail Price */}
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              placeholder="Retail"
                              value={row.RetailPrice || "0"}
                              onChange={(e) =>
                                handlePreviewFieldChange(
                                  row.id,
                                  "RetailPrice",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: "11px", width: "100%" }}
                            />
                            {/* B2C Discount */}
                            <div
                              className="input-group input-group-sm"
                              style={{ width: "100%" }}
                            >
                              <select
                                className="form-select form-select-sm"
                                value={row.B2cDiscountMode || ""}
                                onChange={(e) =>
                                  handlePreviewFieldChange(
                                    row.id,
                                    "B2cDiscountMode",
                                    e.target.value,
                                  )
                                }
                                style={{ fontSize: "11px", width: "70px" }}
                              >
                                <option value="">B2C Mode</option>
                                <option value="Amount">Amt</option>
                                <option value="Percent">%</option>
                              </select>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                placeholder="B2C Disc"
                                value={row.B2cDiscountValue || "0"}
                                onChange={(e) =>
                                  handlePreviewFieldChange(
                                    row.id,
                                    "B2cDiscountValue",
                                    e.target.value,
                                  )
                                }
                                style={{ fontSize: "11px" }}
                              />
                            </div>
                            {/* B2C Selling Price (Auto) */}
                            {(() => {
                              const retail = parseFloat(row.RetailPrice) || 0;
                              const b2cMode = (
                                row.B2cDiscountMode || ""
                              ).toLowerCase();
                              const discValue =
                                parseFloat(row.B2cDiscountValue) || 0;
                              let b2cFinal = retail;
                              if (b2cMode === "percent" && discValue > 0) {
                                b2cFinal = retail - (discValue / 100) * retail;
                              } else if (
                                b2cMode === "amount" &&
                                discValue > 0
                              ) {
                                b2cFinal = retail - discValue;
                              }
                              return (
                                <div
                                  style={{
                                    fontSize: "10px",
                                    color: "#444",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  B2C Price: ₹{b2cFinal.toFixed(2)}
                                </div>
                              );
                            })()}
                            {/* B2B Discount */}
                            <div
                              className="input-group input-group-sm"
                              style={{ width: "100%" }}
                            >
                              <select
                                className="form-select form-select-sm"
                                value={row.B2bDiscountMode || ""}
                                onChange={(e) =>
                                  handlePreviewFieldChange(
                                    row.id,
                                    "B2bDiscountMode",
                                    e.target.value,
                                  )
                                }
                                style={{ fontSize: "11px", width: "70px" }}
                              >
                                <option value="">B2B Mode</option>
                                <option value="Amount">Amt</option>
                                <option value="Percent">%</option>
                              </select>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                placeholder="B2B Disc"
                                value={row.B2bDiscountValue || "0"}
                                onChange={(e) =>
                                  handlePreviewFieldChange(
                                    row.id,
                                    "B2bDiscountValue",
                                    e.target.value,
                                  )
                                }
                                style={{ fontSize: "11px" }}
                              />
                            </div>
                            {/* B2B Selling Price (Auto) */}
                            {(() => {
                              const retail = parseFloat(row.RetailPrice) || 0;
                              const b2bMode = (
                                row.B2bDiscountMode || ""
                              ).toLowerCase();
                              const discValue =
                                parseFloat(row.B2bDiscountValue) || 0;
                              let b2bFinal = retail;
                              if (b2bMode === "percent" && discValue > 0) {
                                b2bFinal = retail - (discValue / 100) * retail;
                              } else if (
                                b2bMode === "amount" &&
                                discValue > 0
                              ) {
                                b2bFinal = retail - discValue;
                              }
                              return (
                                <div
                                  style={{
                                    fontSize: "10px",
                                    color: "#444",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  B2B Price: ₹{b2bFinal.toFixed(2)}
                                </div>
                              );
                            })()}
                          </div>
                        ) : (
                          // Non-Steel: keep original
                          <>
                            <div className="w-100" style={{ fontSize: "11px" }}>
                              <div className="mb-2">
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={row.RetailPrice || "0"}
                                  onChange={(e) =>
                                    handlePreviewFieldChange(
                                      row.id,
                                      "RetailPrice",
                                      e.target.value,
                                    )
                                  }
                                  style={{ fontSize: "11px", width: "100px" }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </td>
                      {/* B2b Discount Mode */}
                    <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.B2bDiscountMode || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "b2bDiscountMode",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "90px" }}
                        >
                          <option value="percent">Percent</option>
                          <option value="amount">Amount</option>
                        </select>
                      </td>
                      {/* B2b Discount Value */}

                       <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={row.B2bDiscountValue || ""}
                            onChange={(e) =>
                              handlePreviewFieldChange(
                                row.id,
                                "b2bDiscountValue",
                                e.target.value,
                              )
                            }
                            style={{ fontSize: "11px", width: "80px" }}
                            placeholder="0"
                          />
                      </td>

                      {/* B2c Discount Mode */}
                       <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.B2cDiscountMode || "per"}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "b2cDiscountMode",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "90px" }}
                        >
                          <option value="percent">Percent</option>
                          <option value="amount">Amount</option>
                        </select>
                      </td>
                      {/* B2c Discount Value */}
                       <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={row.B2cDiscountValue || ""}
                            onChange={(e) =>
                              handlePreviewFieldChange(
                                row.id,
                                "b2cDiscountValue",
                                e.target.value,
                              )
                            }
                            style={{ fontSize: "11px", width: "80px" }}
                            placeholder="0"
                          />
                      </td>

                      {!["steel", "steels"].includes(
                        (row.CategoryName || "").toLowerCase(),
                      ) && (
                        <td>
                          {/* 2. Quantity & Price Tiers */}
                          <div className="mt-2">
                            {/* Based On Selector */}
                            <div className="mb-1">
                              <select
                                className="form-select form-select-sm"
                                value={qtyPriceBasedOn[row.id] || "bags"}
                                onChange={(e) => {
                                  const newBasedOn = e.target.value;
                                  setQtyPriceBasedOn((prev) => ({
                                    ...prev,
                                    [row.id]: newBasedOn,
                                  }));
                                  if (!qtyPriceRows[row.id]) {
                                    setQtyPriceRows((prev) => ({
                                      ...prev,
                                      [row.id]: [
                                        {
                                          min: "",
                                          max: "",
                                          setB2bPrice: "",
                                          setB2cPrice: "",
                                        },
                                      ],
                                    }));
                                  }
                                }}
                                style={{ fontSize: "11px", width: "100px" }}
                              >
                                <option value="bags">Bags</option>
                                <option value="weight">Kg</option>
                                <option value="MT">MT</option>
                                <option value="Ltr">Ltr</option>
                                <option value="Qty">Qty</option>
                                <option value="Unit">Unit</option>
                              </select>
                            </div>
                            {/* Rows */}
                            {(qtyPriceRows[row.id] || []).map((tier, idx) => (
                              <div
                                key={idx}
                                className="d-flex gap-1 mb-1 align-items-center"
                              >
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  placeholder="Min"
                                  value={tier.min}
                                  onChange={(e) =>
                                    setQtyPriceRows((prev) => {
                                      const newRows = [...(prev[row.id] || [])];
                                      newRows[idx] = {
                                        ...newRows[idx],
                                        min: e.target.value,
                                      };
                                      return {
                                        ...prev,
                                        [row.id]: newRows,
                                      };
                                    })
                                  }
                                  style={{
                                    fontSize: "10px",
                                    width: "45px",
                                  }}
                                />
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  placeholder="Max"
                                  value={tier.max}
                                  onChange={(e) =>
                                    setQtyPriceRows((prev) => {
                                      const newRows = [...(prev[row.id] || [])];
                                      newRows[idx] = {
                                        ...newRows[idx],
                                        max: e.target.value,
                                      };
                                      return {
                                        ...prev,
                                        [row.id]: newRows,
                                      };
                                    })
                                  }
                                  style={{
                                    fontSize: "10px",
                                    width: "45px",
                                  }}
                                />
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  placeholder="B2C"
                                  value={tier.setB2cPrice}
                                  onChange={(e) =>
                                    setQtyPriceRows((prev) => {
                                      const newRows = [...(prev[row.id] || [])];
                                      newRows[idx] = {
                                        ...newRows[idx],
                                        setB2cPrice: e.target.value,
                                      };
                                      return {
                                        ...prev,
                                        [row.id]: newRows,
                                      };
                                    })
                                  }
                                  style={{
                                    fontSize: "10px",
                                    width: "50px",
                                  }}
                                />
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  placeholder="B2B"
                                  value={tier.setB2bPrice}
                                  onChange={(e) =>
                                    setQtyPriceRows((prev) => {
                                      const newRows = [...(prev[row.id] || [])];
                                      newRows[idx] = {
                                        ...newRows[idx],
                                        setB2bPrice: e.target.value,
                                      };
                                      return {
                                        ...prev,
                                        [row.id]: newRows,
                                      };
                                    })
                                  }
                                  style={{
                                    fontSize: "10px",
                                    width: "50px",
                                  }}
                                />
                                {idx === 0 && (
                                  <PlusCircle
                                    size={14}
                                    style={{
                                      color: "blue",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setQtyPriceRows((prev) => {
                                        const newRows = [
                                          ...(prev[row.id] || []),
                                          {
                                            min: "",
                                            max: "",
                                            setB2bPrice: "",
                                            setB2cPrice: "",
                                          },
                                        ];
                                        return {
                                          ...prev,
                                          [row.id]: newRows,
                                        };
                                      })
                                    }
                                  />
                                )}
                                {idx > 0 && (
                                  <MinusCircle
                                    size={14}
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setQtyPriceRows((prev) => {
                                        const newRows = [
                                          ...(prev[row.id] || []),
                                        ].filter((_, i) => i !== idx);
                                        return {
                                          ...prev,
                                          [row.id]: newRows,
                                        };
                                      })
                                    }
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        </td>
                        )}
                    
                      {/* B2B Flag */}
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.B2bFlag ? "Yes" : "No"}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "B2bFlag",
                              e.target.value === "Yes",
                            )
                          }
                          style={{ fontSize: "12px", width: "70px" }}
                        >
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </td>
                      {/* B2C Flag */}
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.B2cFlag ? "Yes" : "No"}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "B2cFlag",
                              e.target.value === "Yes",
                            )
                          }
                          style={{ fontSize: "12px", width: "70px" }}
                        >
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </td>
                      {/* Status */}
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.Status || "active"}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "Status",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "90px" }}
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </td>
                      {/* Description */}
                      <td>
                        <textarea
                          className="form-control form-control-sm"
                          value={row.Description || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "Description",
                              e.target.value,
                            )
                          }
                          rows="2"
                          style={{ fontSize: "11px", width: "120px" }}
                          title={row.Description || ""}
                        />
                      </td>
                      {/* Highlight */}
                      <td>
                        <textarea
                          className="form-control form-control-sm"
                          value={row.Highlight || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "Highlight",
                              e.target.value,
                            )
                          }
                          rows="2"
                          style={{ fontSize: "11px", width: "120px" }}
                          title={row.Highlight || ""}
                        />
                      </td>
                      {/* Main Image */}
                      <td>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            setFileMap((prev) => ({
                              ...prev,
                              [row.id]: e.target.files[0],
                            }))
                          }
                          style={{ fontSize: "11px" }}
                        />
                      </td>
                      {/* Extra Images */}
                      <td>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={(e) =>
                            setExtraImageMap((prev) => ({
                              ...prev,
                              [row.id]: Array.from(e.target.files),
                            }))
                          }
                          style={{ fontSize: "11px" }}
                        />
                      </td>
                      {/* Warranty Mode */}
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={row.WarrantyMode || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "WarrantyMode",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "90px" }}
                        >
                          <option value="">--Select--</option>
                          <option value="month">Month</option>
                          <option value="year">Year</option>
                        </select>
                      </td>
                      {/* Warranty Period */}
                      <td>
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          value={row.WarrantyPeriod || "0"}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "WarrantyPeriod",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "70px" }}
                        />
                      </td>
                      {/* Warranty Label */}
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={row.WarrantyLabel || ""}
                          onChange={(e) =>
                            handlePreviewFieldChange(
                              row.id,
                              "WarrantyLabel",
                              e.target.value,
                            )
                          }
                          style={{ fontSize: "12px", width: "100px" }}
                        />
                      </td>
                      {/* Action */}
                      <td style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          onClick={() =>
                            setImportPreview((prev) =>
                              prev.filter((r) => r.id !== row.id),
                            )
                          }
                          style={{
                            background: "none",
                            border: "none",
                            color: "#e74c3c",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <Trash2 size={16} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              style={{
                marginTop: "20px",
                textAlign: "right",
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              {/* <button
                className="btn btn-secondary"
                onClick={handleDownloadSampleCSV}
                style={{ height: "40px" }}
              >
                Download Sample CSV
              </button> */}
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setIsImportModalOpen(false);
                  setImportPreview([]);
                  setFileMap({});
                }}
                style={{ height: "40px" }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleStartImport}
                disabled={importPreview.length === 0}
                style={{ height: "40px" }}
              >
                Start Import
              </button>
            </div>
          </div>
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        accept=".csv"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </>
  );
};

export default ListProduct;

const CustomDropdown = ({
  handleDownloadCSV,
  handleOpenImportInstructions,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
    { label: "Import", value: "import" },
  ];

  const handleSelect = (opt) => {
  setSelected(opt.label);
  setIsOpen(false);
  
  if (opt.value === "export") {
    // ✅ Export = current page only (but selected overrides)
    handleDownloadCSV("current");
  } else if (opt.value === "exportAll") {
    // ✅ Export All = entire dataset (but selected overrides)
    handleDownloadCSV("all");
  } else if (opt.value === "import") {
    handleOpenImportInstructions();
  }
  
  setSelected("Options");
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  brands,
  categories,
  products,
  onClick,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
      onClick={onClick}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.categoryId}
            onChange={(e) => onFilterChange("categoryId", e.target.value)}
          >
            <option value="">Categories</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.brandId}
            onChange={(e) => onFilterChange("brandId", e.target.value)}
          >
            <option value="">Brand</option>
            {brands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.productId}
            onChange={(e) => onFilterChange("productId", e.target.value)}
          >
            <option value="">Product</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name}
                {product.brandName ? ` (${product.brandName})` : ""}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};
